export default "__VITE_ASSET__D9k8DXHO__"